import { API_URL } from '../config';
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import Layout from './Layout';
import EventContext from '../contexts/EventContext';
import useApiUrlTranslation from './useApiUrlTranslation';


const PlansAction = () => {
    const { currentEvent } = useContext(EventContext);
    const [cycleLangEventLigneList, setCycleLangEventLigneList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    useEffect(() => {
        const getCycleLangEventLigne = async () => {
            if (!currentEvent || !currentEvent.event_ligne) return;
            setLoading(true);
            await fetch(`${apiUrlTranslation}?action=getCycleLangEventLigne&params= WHERE id_event_ligne=${currentEvent.event_ligne.id_event_ligne} `)
                .then(res => res.json())
                .then(res => setCycleLangEventLigneList(res))
                .finally(() => setLoading(false));
        };
        getCycleLangEventLigne();
    }, [currentEvent]);

    // Animation variants supprimés

    return (
        <Layout>
            <div className="min-h-screen w-full flex items-center justify-center" >
                <div className="w-full p-4 md:p-8">
                    <h2 className="text-4xl font-extrabold text-center mb-12 text-white drop-shadow-xl tracking-tight">
                        Plans d'Action
                    </h2>
                    {loading ? (
                        <div className="flex flex-col items-center justify-center py-24">
                            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-400 border-opacity-60 mb-6"></div>
                            <span className="text-white text-lg font-medium">Loading...</span>
                        </div>
                    ) : (
                        <div
                            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8"
                        >
                            {cycleLangEventLigneList && cycleLangEventLigneList
                                .filter(cycleLangEventLigne => cycleLangEventLigne.id_cycle_lang.cycle_lang_type === "collectif_planaction")
                                .map(cycleLangEventLigne => {
                                    const cycle_lang = cycleLangEventLigne.id_cycle_lang;
                                    return (
                                        <div
                                            key={cycle_lang.id_cycle_lang}
                                            className="rounded-2xl shadow-2xl overflow-hidden flex flex-col items-center text-center p-8 border-x border-y border-neutral-800 backdrop-blur-xl bg-neutral-900 hover:bg-white/20 transition-all duration-300"
                                        >
                                            <div className="w-24 h-24 flex items-center justify-center mb-6 p-2 bg-white/30 rounded-full backdrop-blur-xl shadow-lg">
                                                <img src={cycle_lang.logo_better.small} alt={cycle_lang.nom_cycle_lang} className="max-w-full max-h-full object-contain" />
                                            </div>
                                            <h3 className="text-xl font-bold mb-4 h-16 flex items-center text-white/95 drop-shadow-lg">{cycle_lang.nom_cycle_lang}</h3>
                                            <a href={`/events/${currentEvent.id_event}/collectifs/${cycle_lang.id_cycle_lang}`}
                                                className="mt-auto bg-blue-500 hover:from-blue-600 hover:to-purple-600 text-white  py-3 px-8 rounded-full transition-all duration-300 shadow-md hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2">
                                                En savoir plus
                                            </a>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default PlansAction;